import { Form } from '@/components'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import OtherDonorsModal from '../OtherDonorsModal'

function OtherDonorsGroup({
  donors,
  values,
  setFieldValue,
  fieldName,
}) {
  const [active, setActive] = useState(false)
  const [search, setSearch] = useState('')
  const [page, setPage] = useState(1)
  const [draftExcludedDonorIds, setDraftExcludedDonorIds] = useState([])
  const take = 30
  const excludedDonorIds = values[fieldName] || []
  const donorIds = donors.map((donor) => donor.id)
  const selectedCount = donorIds.filter((id) => !excludedDonorIds.includes(id)).length
  const draftSelectedCount = donorIds
    .filter((id) => !draftExcludedDonorIds.includes(id)).length
  const name = search.toLowerCase()
  const filteredDonors = name
    ? donors.filter((donor) => donor.fullName.toLowerCase().includes(name))
    : donors
  const pages = Math.ceil(filteredDonors.length / take)
  const visibleDonors = filteredDonors.slice((page - 1) * take, page * take)
  let selectionSummary = `${selectedCount} de ${donors.length} doadores incluídos`

  if (selectedCount === donors.length) {
    selectionSummary = `Todos os ${donors.length} doadores estão incluídos`
  }
  if (selectedCount === 0) selectionSummary = 'Nenhum doador incluído'

  useEffect(() => {
    if (page > pages && pages > 0) setPage(pages)
  }, [page, pages])

  if (!donors.length) return null

  function toggleDonor(id) {
    const next = draftExcludedDonorIds.includes(id)
      ? draftExcludedDonorIds.filter((item) => item !== id)
      : [...draftExcludedDonorIds, id]
    setDraftExcludedDonorIds(next)
  }

  function checkAll() {
    setDraftExcludedDonorIds(
      draftExcludedDonorIds.filter((id) => !donorIds.includes(id)),
    )
  }

  function uncheckAll() {
    setDraftExcludedDonorIds([
      ...draftExcludedDonorIds,
      ...donorIds.filter((id) => !draftExcludedDonorIds.includes(id)),
    ])
  }

  function close() {
    setActive(false)
    setSearch('')
    setPage(1)
  }

  function open() {
    setDraftExcludedDonorIds(excludedDonorIds)
    setActive(true)
  }

  function applySelection() {
    setFieldValue(fieldName, draftExcludedDonorIds)
    close()
  }

  return (
    <>
      <div className="divider text-center" data-content="Outros doadores" />
      <Form.Group>
        <div className="bg-gray s-rounded p-2 mb-2">
          <span className="text-small ml-1">{selectionSummary}</span>
        </div>
        <button
          type="button"
          className="btn btn-sm btn-block"
          onClick={open}
        >
          <i className="fas fa-user-edit" />
          &nbsp;Alterar seleção
        </button>
      </Form.Group>

      <OtherDonorsModal
        active={active}
        donors={donors}
        visibleDonors={visibleDonors}
        draftExcludedDonorIds={draftExcludedDonorIds}
        draftSelectedCount={draftSelectedCount}
        filteredDonorsCount={filteredDonors.length}
        page={page}
        pages={pages}
        setPage={setPage}
        search={search}
        setSearch={setSearch}
        onClose={close}
        onSave={applySelection}
        onCheckAll={checkAll}
        onUncheckAll={uncheckAll}
        onToggleDonor={toggleDonor}
      />
    </>
  )
}

OtherDonorsGroup.propTypes = {
  donors: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    fullName: PropTypes.string,
    donationsCount: PropTypes.number,
  })).isRequired,
  values: PropTypes.objectOf(PropTypes.any).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  fieldName: PropTypes.string.isRequired,
}

export default OtherDonorsGroup
